import { Component } from '@angular/core';
import { CatalogSectionService } from './catalog-section.service';
import {City, CityService} from './city.service';
import {UserService} from './user.service';
import {CookieService} from 'ngx-cookie';

@Component({
  selector: 'app-footer',
  templateUrl: '../templates/footer.component.html',
  styleUrls: ['../styles/components/footer.component.less']
})
export class FooterComponent {
  cities: City[] = [];
  cityService_PROPERTY_INFLECTED_VALUE: any;
  constructor(
    public userService: UserService,
    public cityService: CityService,
    public sectionService: CatalogSectionService,
    private cookie: CookieService) {}

  public async getCities() {
    try {
      this.cities = await this.cityService.get();
      const current = this.cookie.get('city');
      if (current) {
        this.cityService.city = this.cities.find((c) => c.CODE === current);
      }
    } catch (e) {}
  }
}
